export enum PageAction {
  externalRedirect = 'md-vnext-externalRedirect',
  createApiKey = 'md-vnext-apiKeys-create',
  updateApiKey = 'md-vnext-apiKeys-update',
  submitDirectorDetails = 'md-vnext-application-submitDirectorDetails',
  submitDirectorDocument = 'md-vnext-application-submitDirectorDocument',
  submitPrimaryContact = 'md-vnext-application-submitPrimaryContact',
  submitSettlementDetails = 'md-vnext-application-submitSettlementDetails',
  skipSettlementDetails = 'md-vnext-application-skipSettlementDetails',
  auth0Login = 'md-vnext-auth0-login',
  createCliInvite = 'md-vnext-cliInvite-create',
  searchCliInvites = 'md-vnext-cliInvite-search',
  searchCustomers = 'md-vnext-customers-search',
  fetchCompletedOrders = 'md-vnext-dashboard-fetchCompletedOrders',
  fetchCustomerOrders = 'md-vnext-customers-fetchOrders',
  fetchGrossSales = 'md-vnext-dashboard-fetchGrossSales',
  fetchOrdersToReview = 'md-vnext-dashboard-fetchOrdersToReview',
  loadDisbursementSchedule = 'md-vnext-disbursements-loadSchedule',
  generateDisbursementReport = 'md-vnext-disbursements-generate',
  openedHelpCentre = 'md-vnext-helpcentre-opened',
  openedHelpCentreMainPage = 'md-vnext-helpcentre-mainPageOpened',
  openedHelpCentreCategoryPage = 'md-vnext-helpcentre-categoryPageOpened',
  openedHelpCentreCategory = 'md-vnext-helpcentre-categoryOpened',
  openedHelpCentreArticle = 'md-vnext-helpcentre-articleOpened',
  initialLoad = 'md-vnext-initialLoad',
  createInvite = 'md-vnext-invite-create',
  fetchPosVendorUrl = 'md-vnext-posVendorUrl-fetch',
  openPosVendorUrl = 'md-vnext-posVendorUrl-open',
  cancelOperationRequest = 'md-vnext-operationrequests-cancel',
  addProductDetails = 'md-vnext-orders-addProductDetails',
  openOrderActions = 'md-vnext-orders-openActions',
  cancelOrder = 'md-vnext-orders-cancel',
  completeOrder = 'md-vnext-orders-complete',
  createOrder = 'md-vnext-orders-create',
  createOrderSuccess = 'md-vnext-orders-createSuccess',
  remoteOrder = 'md-vnext-orders-createRemote',
  fetchOrder = 'md-vnext-orders-fetch',
  refundOrder = 'md-vnext-orders-refund',
  quoteOrder = 'md-vnext-orders-quote',
  remindCustomer = 'md-vnext-orders-remindCustomer',
  resendOrder = 'md-vnext-orders-resend',
  removeOrder = 'md-vnext-orders-remove',
  searchOrders = 'md-vnext-orders-search',
  updateOrderReference = 'md-vnext-orders-updateReference',
  updateQuickActions = 'md-vnext-quickactions-update',
  calculateRepayments = 'md-vnext-repayments-calculate',
  fetchStoreProfile = 'md-vnext-storeProfile-fetch',
  submitStoreProfile = 'md-vnext-storeProfile-submit',
  generateStoreTileLogo = 'md-vnext-storeTile-generateLogo',
  generateStoreTileBackground = 'md-vnext-storeTile-generateBackground',
  loadUserPreferences = 'md-vnext-userpreferences-get',
  createUser = 'md-vnext-users-create',
  deleteUser = 'md-vnext-users-delete',
  searchUsers = 'md-vnext-users-search',
  updateUser = 'md-vnext-users-update',
  updateNotificationSettings = 'md-vnext-notificationSettings-update',
  fetchNotificationSettings = 'md-vnext-notificationSettings-fetch',
  openedSetupArticle = 'md-vnext-setupArticle-opened',
  openedSetupGuide = 'md-vnext-setupGuide-opened-banner',
  openedSetupGuideHC = 'md-vnext-setupGuide-opened-helpCentre',
  dismissedSetupGuide = 'md-vnext-setupGuide-dismissed',
  fetchZipCampaigns = 'md-vnext-zipCampaigns-fetch',
  openedZipCampaign = 'md-vnext-zipCampaigns-openedCampaign',
  openedZipCampaignAssets = 'md-vnext-zipCampaigns-openedAssets',
  submitStoreCategories = 'md-vnext-storeCategories-submit',
  fetchStoreCategories = 'md-vnext-storeCategories-fetch',
  openedUpdateMerchantForm = 'md-vnext-accountUpdate-merchant',
  sendMerchantOwnershipForm = 'md-vnext-accountUpdate-ownership-merchant',
  sendBranchOwnershipForm = 'md-vnext-accountUpdate-ownership-branch',
  openedUpdateBranchForm = 'md-vnext-accountUpdate-branch',
  openedNewBranchesForm = 'md-vnext-accountUpdate-newBranches',
  openedNewBranchForm = 'md-vnext-accountUpdate-newBranch',
  fetchContentfulContent = 'md-vnext-contentful-fetchContent',
  clickedContentfulAction = 'md-vnext-contentful-clickedAction',
  purchasePlan = 'md-vnext-purchasePlan',
  clickedPurchasePlanSend = 'md-vnext-purchasePlan-send',
  clickedOpenPurchasePlanLink = 'md-vnext-purchasePlan-link',
  mfaUserManagementUpdate = 'md-vnext-mfa-userManagement-update',
  mfaModalSelfSetup = 'md-vnext-mfa-modal-self-setup',
  mfaModalSelfSkip = 'md-vnext-mfa-modal-self-skip',
  mfaModalAdminEnableSettings = 'md-vnext-mfa-modal-admin-enableSettings',
  mfaModalAdminRemindLater = 'md-vnext-mfa-modal-admin-remindLater',
  mfaCompleteBannerClick = 'md-vnext-mfa-complete-banner-click',
  mfaCompleteDialogClick = 'md-vnext-mfa-complete-dialog-click',
  quickActionListEditDialogOpen = 'md-vnext-quick-action-list-edit-dialog-open',
  productsAndOffersTableSorting = 'md-vnext-products-and-offers-table-sorting',
  productsAndOffersHowItWorksDialogOpen = 'md-vnext-products-and-offers-how-it-works-dialog-open',
  productsAndOffersCustomiseOffersSidebarOps = 'md-vnext-products-and-offers-customise-offers-sidebar',
  merchantOnboardingCreate = 'md-vnext-merchant-onboarding-create',
  merchantOnboardingPatchSignUpInfo = 'md-vnext-merchant-onboarding-patch-signup-info',
  merchantOnboardingPatchActivationInfo = 'md-vnext-merchant-onboarding-patch-activation-info',
  merchantOnboardingPatchPaymentUseCase = 'md-vnext-merchant-onboarding-patch-payment-use-case',
  merchantOnboardingPatchEcommercePlatform = 'md-vnext-merchant-onboarding-patch-ecommerce-platform',
  merchantOnboardingPatchPaymentProvider = 'md-vnext-merchant-onboarding-patch-payment-provider',
  merchantOnboardingPatchPOSPlatform = 'md-vnext-merchant-onboarding-patch-pos-platform',
  merchantOnboardingPatchAnnualSales = 'md-vnext-merchant-onboarding-patch-annual-sales',
  merchantOnboardingGetFormOptions = 'md-vnext-merchant-onboarding-get-form-options',
  merchantOnboardingAbnLookup = 'md-vnext-merchant-onboarding-abn-lookup',
  merchantOnboardingAbnCheck = 'md-vnext-merchant-onboarding-abn-check',
  merchantOnboardingIndustryTypeLoad = 'md-vnext-merchant-onboarding-industry-type-load',
  merchantOnboardingAbnInit = 'md-vnext-merchant-onboarding-abn-init',
  merchantOnboardingPVSignUp = 'pv_application_signup',
  merchantOnboardingPVABNAndBusinessDetails = 'pv_application_abn_and_business_details',
  merchantOnboardingPVTradeChannel = 'pv_application_tradechannel',
  merchantOnboardingPVECommerce = 'pv_application_ecomm',
  merchantOnboardingPVPaymentProvider = 'pv_application_paymentprovider',
  merchantOnboardingPVPOSPlatform = 'pv_application_posplatform',
  merchantOnboardingPVTTV = 'pv_application_ttv',
  merchantOnboardingPVPassword = 'pv_application_password',
  merchantOnboardingPVPrequalDecision = 'pv_application_prequal_decision',
  merchantOnboardingPVActivationDashboard = 'pv_dashboard_activation',
  merchantOnboardingPVBusinessDetails = 'pv_dashboard_businessdetails',
  merchantOnboardingPVDirectorDetails = 'pv_dashboard_directordetails',
  merchantOnboardingPVUploadDirectorDetails = 'pv_dashboard_directordetails_upload',
  merchantOnboardingPVConfirmDirectorDetails = 'pv_dashboard_directordetails_confirm',
  merchantOnboardingPVUploadSettlementDetails = 'pv_dashboard_settlementdetails_upload',
  merchantOnboardingPVConfirmSettlementDetails = 'pv_dashboard_settlementdetails_confirm',
  merchantOnboardingPVPostSubmission = 'pv_dashboard_postsubmission',
  merchantOnboardingUASignUp = 'ua_application_signup',
  merchantOnboardingUAABNStatus = 'ua_application_abnstatus',
  merchantOnboardingUABusinessDetails = 'ua_application_businessdetails',
  merchantOnboardingUABusinessDetailsAITradingName = 'ua_application_businessdetails_tradingname_ai',
  merchantOnboardingUABusinessDetailsDropdownIndustryType = 'ua_application_businessdetails_industrytype_dropdown',
  merchantOnboardingUABusinessDetailsAIIndustryType = 'ua_application_businessdetails_industrytype_ai',
  merchantOnboardingUATradeChannel = 'ua_application_tradechannel',
  merchantOnboardingUAECommerce = 'ua_application_ecomm',
  merchantOnboardingUAPaymentProvider = 'ua_application_paymentprovider',
  merchantOnboardingUAPOSPlatform = 'ua_application_posplatform',
  merchantOnboardingUATTV = 'ua_application_ttv',
  merchantOnboardingUAStripeIntegration = 'ua_application_stripeintegration',
  merchantOnboardingUAStripeIntegrationZipIntegratedMerchant = 'ua_application_stripeintegration_zipintegratedmerchant',
  merchantOnboardingUAStripeIntegrationFinaliseApplication = 'ua_application_stripeintegration_finaliseapplication',
  merchantOnboardingUAPasswordComplete = 'ua_application_passwordcomplete',
  merchantOnboardingUAEnterBusinessDetails = 'ua_businessdetails_enter',
  merchantOnboardingUAConfirmBusinessDetails = 'ua_businessdetails_confirm',
  merchantOnboardingUAEnterDirectorDetails = 'ua_directordetails_enter',
  merchantOnboardingUAUploadDirectorDocument = 'ua_directordetails_documentupload',
  merchantOnboardingUAConfirmDirectorDetails = 'ua_directordetails_confirm',
  merchantOnboardingUAEnterSettlementDetails = 'ua_settlementdetails_enter',
  merchantOnboardingUAUploadSettlementDocument = 'ua_settlementdetails_documentupload',
  merchantOnboardingUAConfirmSettlementDetails = 'ua_settlementdetails_confirm',
  merchantOnboardingUAPostSubmissionViewAndSignContract = 'ua_postsubmission_viewandsigncontract',
}
